import { Box, Button, Typography } from "@mui/material";
import React from "react";
import SubHeader from "../../../../components/SubHeader";
import color from "../../../../constants/color";
import style from "./style";
import ExpenseList from "./ExpenseList";
import { useNavigate } from "react-router-dom";

const ExpensePage = ({data,deleteExpense,page,setPage,totalCount}) => {
  const navigate = useNavigate()
  return(
    <>
      <Box px="15px" pt="20px" display="flex" justifyContent="space-between" alignItems="center">
        <Typography variant="h5" sx={style.heading}>Expense List</Typography>

        <Box display="flex" justifyContent={{ xs: "start", md: "end" }} alignItems={{ xs: "start", md: "end" }}>
          <Button variant="contained" color="success" sx={style.checkinBtn} onClick={() =>navigate("/dashboard/addExpense")}>
            {"+ Add Expense"}
          </Button>

        </Box>


      </Box>
      <Box sx={{ backgroundColor: color.card, m: 2, borderRadius: "20px" }}>
        <SubHeader
          isShow={false}
          search
          sortBy/>
      
        <ExpenseList data={data} setPage={setPage} page={page} totalCount={totalCount} deleteExpense={deleteExpense} />

      </Box></>
  )
}

export default ExpensePage